import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog, DialogButton, DialogTitle } from "@bookips/sds";
/**
 * 연간권 카드의 '유의사항 보기' 다이얼로그.
 * 본문 길이가 상품마다 달라 SDS Dialog 의 scroll 을 사용한다. (SDS ConfirmDialog 에는 스크롤 옵션이 없음)
 */ const PassNoticeDialog = (param)=>{
    let { isOpen , onClose , info  } = param;
    return /*#__PURE__*/ _jsx(Dialog, {
        open: isOpen,
        onOpenChange: (open)=>!open && onClose(),
        scroll: true,
        // SDS Dialog 의 size='md' 는 고정 폭(520px)이라 모바일 폭만 Tailwind 로 보정한다.
        classes: {
            contentWrapper: "max-sm:w-[calc(100vw-40px)]",
            content: "px-7 max-sm:px-5"
        },
        title: /*#__PURE__*/ _jsx(DialogTitle, {
            title: "상세 내용",
            classes: {
                root: "max-sm:p-5 max-sm:pb-0"
            }
        }),
        footer: /*#__PURE__*/ _jsx(DialogButton, {
            confirmText: "확인",
            onConfirm: onClose,
            classes: {
                root: "max-sm:p-5 max-sm:pt-0"
            }
        }),
        children: /*#__PURE__*/ _jsx("p", {
            className: "typo-body1 text-primary whitespace-pre-line",
            children: info
        })
    });
};
export default PassNoticeDialog;
